var React = require('react');

function SearchIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".search-icon-svg{fill:#999;}")),React.createElement("path",{"id":"Rounded_Rectangle_4","data-name":"Rounded Rectangle 4","className":"search-icon-svg","d":"M9.45,9.45a1,1,0,0,1,1.41,0l2.83,2.83a1,1,0,0,1-1.39,1.44l0,0L9.45,10.87A1.08,1.08,0,0,1,9.45,9.45Z","transform":"translate(-0.02 -0.01)","key":1}),React.createElement("path",{"className":"search-icon-svg","d":"M6.06,0a6,6,0,1,0,6,6A6,6,0,0,0,6.06,0Zm.06,10.32A4.33,4.33,0,1,1,10.45,6,4.33,4.33,0,0,1,6.12,10.33Z","transform":"translate(-0.02 -0.01)","key":2})]);
}

SearchIcon.defaultProps = {"id":"Layer_1","data-name":"Layer 1","width":"14","height":"14","viewBox":"0 0 13.98 13.99"};

module.exports = SearchIcon;

SearchIcon.default = SearchIcon;
